interface LogoutIconProps {
  className?: string;
}

export const LogoutIcon = ({ className }: LogoutIconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5M7.5 2.5H6.5C4.84315 2.5 3.5 3.84315 3.5 5.5V14.5C3.5 16.1569 4.84315 17.5 6.5 17.5H7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
